export const morseCode = {
    "a": ".-",
    "b": "-...",
    "c": "-.-.",
    "d": "-..",
    "e": ".",
    "f": "..-.",
    "g": "--.",
    "h": "....",
    "i": "..",
    "j": ".---",
    "k": "-.-",
    "l": ".-..",
    "m": "--",
    "n": "-.",
    "o": "---",
    "p": ".--.",
    "q": "--.-",
    "r": ".-.",
    "s": "...",
    "t": "-",
    "u": "..-",
    "v": "...-",
    "w": ".--",
    "x": "-..-",
    "y": "-.--",
    "z": "--..",
    " ": " "
  }

export const morseDecode = {
  ' ': ' ',
  '-': 't',
  '--': 'm',
  '---': 'o',
  '.': 'e',
  '.-': 'a',
  '.--': 'w',
  '.---': 'j',
  '-.': 'n',
  '-.-': 'k',
  '-.--': 'y',
  '--.': 'g',
  '--.-': 'q',
  '..': 'i',
  '..-': 'u',
  '.-.': 'r',
  '.--.': 'p',
  '-..': 'd',
  '-..-': 'x',
  '-.-.': 'c',
  '--..': 'z',
  '...': 's',
  '...-': 'v',
  '..-.': 'f',
  '.-..': 'l',
  '-...': 'b',
  '....': 'h',
}
export const nodes = [
    {
      id: 'start',
      label: 'start'
    }, {
      id: 'A',
      label: 'A',
    }, {
      id: 'B',
      label: 'B',
    }, {
      id: 'C',
      label: 'C'
    }, {
      id: 'D',
      label: 'D'
    }, {
      id: 'E',
      label: 'E'
    }, {
      id: 'F',
      label: 'F'
    }, {
      id: 'G',
      label: 'G'
    }, {
      id: 'H',
      label: 'H'
    }, {
      id: 'I',
      label: 'I'
    }, {
      id: 'J',
      label: 'J'
    }, {
      id: 'K',
      label: 'K'
    }, {
      id: 'L',
      label: 'L'
    }, {
      id: 'M',
      label: 'M'
    }, {
      id: 'N',
      label: 'N'
    }, {
      id: 'O',
      label: 'O'
    }, {
      id: 'P',
      label: 'P'
    }, {
      id: 'Q',
      label: 'Q'
    }, {
      id: 'R',
      label: 'R'
    }, {
      id: 'S',
      label: 'S'
    }, {
      id: 'T',
      label: 'T'
    }, {
      id: 'U',
      label: 'U'
    }, {
      id: 'V',
      label: 'V'
    }, {
      id: 'W',
      label: 'W'
    }, {
      id: 'X',
      label: 'X'
    }, {
      id: 'Y',
      label: 'Y'
    }, {
      id: 'Z',
      label: 'Z'
    }
  ];

export const edges = [
    {
      source: 'start',
      target: 'E',
      label: '.'
    }, {
      source: 'start',
      target: 'T',
      label: '-'
    }, {
      source: 'E',
      target: 'I',
      label: '.'
    }, {
      source: 'I',
      target: 'S',
      label: '.'
    }, {
      source: 'S',
      target: 'H',
      label: '.'
    }, {
      source: 'U',
      target: 'F',
      label: '.'
    }, {
      source: 'A',
      target: 'R',
      label: '.'
    }, {
      source: 'R',
      target: 'L',
      label: '.'
    }, {
      source: 'W',
      target: 'P',
      label: '.'
    }, {
      source: 'T',
      target: 'N',
      label: '.'
    }, {
      source: 'N',
      target: 'D',
      label: '.'
    }, {
      source: 'D',
      target: 'B',
      label: '.'
    }, {
      source: 'K',
      target: 'C',
      label: '.'
    }, {
      source: 'M',
      target: 'G',
      label: '.'
    }, {
      source: 'G',
      target: 'Z',
      label: '.'
    }, {
      source: 'T',
      target: 'M',
      label: '-'
    }, {
      source: 'M',
      target: 'O',
      label: '-'
    }, {
      source: 'G',
      target: 'Q',
      label: '-'
    }, {
      source: 'N',
      target: 'K',
      label: '-'
    }, {
      source: 'K',
      target: 'Y',
      label: '-'
    }, {
      source: 'D',
      target: 'X',
      label: '-'
    }, {
      source: 'E',
      target: 'A',
      label: '-'
    }, {
      source: 'A',
      target: 'W',
      label: '-'
    }, {
      source: 'W',
      target: 'J',
      label: '-'
    }, {
      source: 'S',
      target: 'V',
      label: '-'
    }, {
      source: 'I',
      target: 'U',
      label: '-'
    }
  ];